module.exports = __webpack_public_path__ + "static/media/family-image-connect@3x.4fbaf7f0.png";